import axios from "axios";

// ID-card endpoints live on the user/root domain (next to id-card-template.php).
const IDCARD_HOST = "https://siliconmindstechnologies.com/";

const GetIdCardTemplates = async ({ payload }) => {
  const formData = new FormData();
  if (payload && payload.session) formData.append("session", payload.session);
  if (payload && payload.course_url) formData.append("course_url", payload.course_url);

  const res = await axios.post(IDCARD_HOST + "admin-get-idcard-templates.php", formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default GetIdCardTemplates;
